/**
 * INDEX.TSX - React Application Entry Point
 * 
 * This is the main entry point for the X(EPI)BLEPSIS medical monitoring React application.
 * It initializes the React application and renders the root App component with
 * React.StrictMode for enhanced development debugging and performance optimization.
 * 
 * Key Features:
 * - React 18+ createRoot API for modern React rendering
 * - StrictMode for development debugging and performance optimization
 * - Global CSS imports for application styling
 * - TypeScript support for type safety
 * 
 * Application Structure:
 * - Root component: App (main application component)
 * - Global styles: index.css (application-wide styling)
 * - React.StrictMode: Enhanced development experience
 * - TypeScript: Type safety and development support
 * 
 * Development Features:
 * - StrictMode: Detects side effects and deprecated APIs
 * - Hot reloading: Automatic updates during development
 * - Error boundaries: Better error handling and debugging
 * - Performance monitoring: React DevTools integration
 */

// React core imports for application initialization
import React from 'react';
import ReactDOM from 'react-dom/client';

// Global CSS imports for application styling
import './index.css';

// Main application component import
import App from './App';

/**
 * REACT APPLICATION INITIALIZATION
 * 
 * Creates the root React element and renders the main App component.
 * Uses React 18+ createRoot API for modern React rendering with
 * StrictMode for enhanced development debugging.
 */
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render the application with StrictMode for development optimization
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 